import { Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { selectOrgCustomization } from "src/store/orgCustomizations/reducer";
  
const LoadingComponent = () => {
    return (
        <>
            <li className='afc-dropdown' style={{
                width: '80%'
            }}>
                <div className="loading-placeholder menu-item" />
            </li>
            <li className='afc-dropdown'>
                <div className="loading-placeholder menu-item" />
            </li>
            <li className='afc-dropdown'>
                <div className="loading-placeholder menu-item w-50" />
            </li>
            <li className='afc-dropdown' style={{
                width: '70%'
            }}>
                <div className="loading-placeholder menu-item" />
            </li>
            <li className='afc-dropdown'>
                <div className="loading-placeholder menu-item" />
            </li>
            <li className='afc-dropdown' style={{
                width: '80%'
            }}>
                <div className="loading-placeholder menu-item" />
            </li>
            <li className='afc-dropdown' style={{
                width: '80%'
            }}>
                <div className="loading-placeholder menu-item" />
            </li>
            <li className='afc-dropdown'>
                <div className="loading-placeholder menu-item" />
            </li>
            <li className='afc-dropdown'>
                <div className="loading-placeholder menu-item w-50" />
            </li>
        </>
    )
}

const VerticalMenuContent = (props) => {
	const {
		menu,
		t,
        modules,
        organization,
        orgCustomization
	} = props;

    const location = useLocation();
    const [ activeMenuIndex, setActiveMenuIndex ] = useState('-1');
    const [ isLoading, setIsLoading ] = useState(true);

    const activateParentDropdown = () => {
        var matchingMenuItem = null;
        var ul = document.getElementById("side-menu");
        var items = ul.getElementsByTagName("a");
        const currentPath = location.pathname;

        for (var i = 0; i < items.length; ++i) {
            if (items[i].pathname.includes(currentPath)) {
                matchingMenuItem = items[i];
                break;
            }
        }

        if (matchingMenuItem) {
            matchingMenuItem.classList.add("active");

            const parent = matchingMenuItem.closest('.afc-dropdown');

            if (parent) {
                parent.classList.add("active")
                return false;
            }
        }
    };

    useEffect(() => {
        activateParentDropdown()
    }, [menu]);

    useEffect(() => {
        setIsLoading(!(!modules.isLoading && modules.featuresLoadingStatus === 'loaded'))
    }, [  
        modules.isLoading,
        modules.featuresLoadingStatus
    ]);

	return (
		<ul className="metismenu list-unstyled" id="side-menu">
            {(() => {
                if(isLoading){
                    return (
                        <LoadingComponent />
                    )
                }

                return menu.map((menuItem, menuItemIndex) => {
                    const subMenuItems = menuItem.items || [];
                    const hasSubMenu = subMenuItems.length > 0;
    
                    return (
                        <li key={menuItemIndex} className={`afc-dropdown ${activeMenuIndex.split('--')[0] === menuItemIndex.toString() ? 'active' : ''}`} onClick={() => setActiveMenuIndex(`${menuItemIndex}`)}>
                            {
                                menuItem.linkType === 'react-router' ? (
                                    <>
                                        {menuItem?.path ? 
                                            <Link to={menuItem.path}
                                                className={`${hasSubMenu ? "has-arrow" : null} waves-effect`}>
                                                    
                                                {typeof menuItem.icon === 'function' ? (
                                                    <menuItem.icon />
                                                ) : (
                                                    <i className={menuItem.icon}></i>
                                                )}
                                                
                                                <span className="ms-1">
                                                    {typeof menuItem.titleKey === "function" ? menuItem.titleKey({
                                                        t,
                                                        organization,
                                                        orgCustomization,
                                                        menuItem
                                                    }) : t(menuItem.titleKey)}
                                                </span>
                                            </Link>
                                        // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                        : <a className={`${hasSubMenu && "has-arrow" } waves-effect`}>
                                                
                                            {typeof menuItem.icon === 'function' ? (
                                                <menuItem.icon />
                                            ) : (
                                                <i className={menuItem.icon}></i>
                                            )}
                                            
                                            <span className="ms-1">
                                                {typeof menuItem.titleKey === "function" ? menuItem.titleKey({
                                                        t,
                                                        organization,
                                                        orgCustomization,
                                                        menuItem
                                                    }) : t(menuItem.titleKey)}
                                            </span>
                                        </a>}
                                    </>
                                ) : (
                                    <a href={menuItem.path}
                                        className="waves-effect" target='_new'>
                                            
                                        {typeof menuItem.icon === 'function' ? (
                                            <menuItem.icon />
                                        ) : (
                                            <i className={menuItem.icon}></i>
                                        )}
                                        
                                        <span className="ms-1">
                                            {typeof menuItem.titleKey === "function" ? menuItem.titleKey({
                                                t,
                                                organization,
                                                orgCustomization,
                                                menuItem
                                            }) : t(menuItem.titleKey)}
                                        </span>
                                    </a>
                                )
                            }
                            
    
                            {
                                hasSubMenu ? (
                                    <ul className="sub-menu">
                                        {subMenuItems.map((subMenuItem, subMenuItemIndex) => {
                                            const subMenuItems2 = subMenuItem.items || [];
                                            const hasSubMenu2 = subMenuItems2.length > 0;
                                            
                                            return (
                                                <li 
                                                    key={subMenuItemIndex}
                                                    className={`${hasSubMenu2 ? 'afc-dropdown' : ''} ${activeMenuIndex === `${menuItemIndex}--${subMenuItemIndex}` ? 'active' : ''}`}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setActiveMenuIndex(`${menuItemIndex}--${subMenuItemIndex}`);
                                                    }}
                                                >
                                                    {
                                                        subMenuItem.linkType === 'react-router' ? (
                                                            <>
                                                                {subMenuItem?.path ? 
                                                                    <Link to={subMenuItem.path}
                                                                        className={`${hasSubMenu2 ? "has-arrow" : ''} waves-effect`}>
                                                                        <span className="ms-1">
                                                                            {typeof subMenuItem.titleKey === "function" ? subMenuItem.titleKey({
                                                                                t,
                                                                                organization,
                                                                                orgCustomization,
                                                                                menuItem: subMenuItem
                                                                            }) : t(subMenuItem.titleKey)}
                                                                        </span>
                                                                    </Link>
                                                                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                                                : <a className={`${hasSubMenu2 && "has-arrow" } waves-effect`}>
                                                                    <span className="ms-1">
                                                                        {typeof subMenuItem.titleKey === "function" ? subMenuItem.titleKey({
                                                                            t,
                                                                            organization,
                                                                            orgCustomization,
                                                                            menuItem: subMenuItem
                                                                        }) : t(subMenuItem.titleKey)}
                                                                    </span>
                                                                </a>}
                                                            </>
                                                        ) : (
                                                            <a href={subMenuItem.path} target="_new">
                                                                {typeof subMenuItem.titleKey === "function" ? subMenuItem.titleKey({
                                                                    t,
                                                                    organization,
                                                                    orgCustomization,
                                                                    menuItem: subMenuItem
                                                                }) : t(subMenuItem.titleKey)}
                                                            </a>
                                                        )
                                                    }

                                                    {
                                                        hasSubMenu2 ? (
                                                            <ul className="sub-menu">
                                                                {subMenuItems2.map((subMenuItem2, subMenuItemIndex2) => {
                                                                    return (
                                                                        <li key={subMenuItemIndex2}>
                                                                            {
                                                                                subMenuItem2.linkType === 'react-router' ? (
                                                                                    <Link to={subMenuItem2.path}>
                                                                                        {typeof subMenuItem2.titleKey === "function" ? subMenuItem2.titleKey({
                                                                                            t,
                                                                                            organization,
                                                                                            orgCustomization,
                                                                                            menuItem: subMenuItem2
                                                                                        }) : t(subMenuItem2.titleKey)}
                                                                                    </Link>
                                                                                ) : (
                                                                                    <a href={subMenuItem2.path} target="_new">
                                                                                        {typeof subMenuItem2.titleKey === "function" ? subMenuItem2.titleKey({
                                                                                            t,
                                                                                            organization,
                                                                                            orgCustomization,
                                                                                            menuItem: subMenuItem2
                                                                                        }) : t(subMenuItem2.titleKey)}
                                                                                    </a>
                                                                                )
                                                                            }
                                                                        </li>
                                                                    );
                                                                })}
                                                            </ul>
                                                        ) : null
                                                    }
                                                </li>
                                            );
                                        })}
                                    </ul>
                                ) : null
                            }
                        </li>
                    );
                })
            })()}
        </ul>
	);
}

const mapStatetoProps = (state) => {
    const { Modules: modules, Organization: organization } = state;
    return {
        modules,
        organization,
        orgCustomization: selectOrgCustomization(state, organization?.id)
    };
};

export default withNamespaces()(
    connect(mapStatetoProps, {})(
        VerticalMenuContent
    )
);